'use client';
import React, { useState, useEffect } from 'react';
import AppLogo from '@/components/ui/AppLogo';

const Header: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'py-3 bg-[rgba(13,13,13,0.85)] backdrop-blur-xl border-b border-[rgba(255,255,255,0.06)]'
          : 'py-5 bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center gap-2">
          <AppLogo
            size={28}
            iconName="BoltIcon"
            text="Invoice"
            className="text-white"
          />
        </div>

        {/* Nav links — hidden on mobile */}
        <nav className="hidden md:flex items-center gap-8">
          {['Features', 'Integrations', 'Pricing', 'Demo'].map((item) => (
            <a
              key={item}
              href={`#${item.toLowerCase()}`}
              className="text-[13px] font-medium text-[#C0C7D0] hover:text-white transition-colors duration-200 tracking-wide"
            >
              {item}
            </a>
          ))}
        </nav>

        {/* CTA */}
        <div className="flex items-center gap-3">
          <a
            href="#calculator"
            className="hidden sm:block btn-ghost px-4 py-2 text-[13px]"
          >
            Run My Numbers
          </a>
          <a
            href="#demo"
            className="btn-teal px-5 py-2.5 text-[13px]"
          >
            Start Free
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;